import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { useAuth } from './AuthContext';

export default function RequireAdmin({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <div className="d-flex justify-content-center mt-5" role="status" aria-label="Checking sign-in">
            <Spinner animation="border" />
        </div>;
    }
    if (!user) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }
    if (user.role !== 'admin') {
        return <Navigate to="/devices" replace />;
    }
    return children;
}
